<template>
  <div
    ref="box"
    :class="['row', 'feature-box-wrapper', isCollapsed ? 'collapsed' : 'open']"
  >
    <!-- Video column -->
    <div
      v-if="showVideo"
      ref="video"
      :class="['col-xs-12', 'col-sm-4', 'col-md-4', 'col-lg-3', 'feature-box-video']"
    >
      <video-embedded
        :style="{ marginTop: videoMarginTop }"
        :url="videoUrl"
        :width="videoWidth"
        :height="videoHeight"
      ></video-embedded>
    </div>

    <!-- Description column -->
    <div
      :class="[
        'col-xs-9',
        'col-sm-' + (showVideo ? 5 : 10),
        'col-md-' + (showVideo ? 6 : 10),
        'col-lg-' + (showVideo ? 7 : 10),
        'col-box-content'
      ]"
    >
      <h2 class="mtm">{{ heading }}</h2>
      <div v-if="!isCollapsed">
        <div v-html="content"></div>
        <slot name="postMiddleCol" />
      </div>
    </div>

    <!-- Extra column slot, by default "Show/Hide" button column -->
    <slot>
      <div
        v-if="useShowHide"
        ref="showHide"
        :class="['col-xs-2', 'col-sm-2', 'col-md-2', 'col-show-hide']"
      >
        <show-hide
          :url="urlUpdateVisibility"
          :visible="!isCollapsed"
          :show-text="showText"
          :hide-text="hideText"
          @change="onShowHide"
        ></show-hide>
      </div>
    </slot>
  </div>
</template>

<script>
import Vue from 'vue';
import ShowHide from '../Shared/ShowHide';
import VideoEmbedded from '../Video/VideoEmbedded';
import showHideMixin from './mixins/show-hide-mixin.js';

const VIDEO_MAX_HEIGHT = 160;

export default {
  components: { VideoEmbedded, ShowHide },
  mixins: [showHideMixin],
  props: {
    heading: {
      type: String,
      default: null
    },
    content: {
      type: String,
      default: null
    },
    videoUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isCollapsed: this.collapsed,
      boxHeight: null,
      boxWidth: null,
      videoWidth: null,
      videoHeight: null
    };
  },
  computed: {
    chevronClass() {
      return 'af-icons-chevron-' + this.isCollapsed ? 'up' : 'down';
    },
    openClosedClass() {
      return this.isCollapsed ? 'closed' : 'open';
    },
    videoMarginTop() {
      if (
        this.boxHeight == null ||
        this.videoWidth == null ||
        this.boxWidth < 768
      ) {
        return null;
      }
      return (this.boxHeight - this.$refs.video.clientHeight) / 2 + 'px';
    },
    showVideo() {
      return !this.isCollapsed && !!this.videoUrl;
    }
  },
  mounted() {
    this.updateSizes();
    setTimeout(() => {
      this.updateSizes();
    }, 50);
    setTimeout(() => {
      this.updateSizes();
    }, 300);
  },
  methods: {
    onShowHide(isVisible) {
      this.isCollapsed = !isVisible;
      if (!this.boxHeight) {
        Vue.nextTick(() => this.updateSizes());
      }
    },
    updateSizes() {
      this.videoWidth = this.$refs.video ? this.$refs.video.clientWidth : null;
      this.videoHeight = Math.min(this.videoWidth * 9 / 16, VIDEO_MAX_HEIGHT);
      this.boxHeight = this.$refs.box ? this.$refs.box.clientHeight : null;
      this.boxWidth = this.$refs.box ? this.$refs.box.clientWidth : null;
    }
  }
};
</script>

<style>
.feature-box-wrapper {
  padding-bottom: 10px;
  background-color: white;
}

.feature-box-video iframe {
  width: 100%;
  max-width: 390px;
}
</style>
